import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { YButton } from '../../../ui/YButton';
import { YInput } from '../../../ui/YInput';
import { YFormField } from '../../../ui/YFormField';

/**
 * Invite-by-email style dialog (UI shell). Parent handles onSubmit / persistence.
 */
export function InviteMemberModal({ show, onHide, onSubmit }) {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    if (!show) return;
    setFullName('');
    setEmail('');
    setPhone('');
  }, [show]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeof onSubmit === 'function') {
      onSubmit({
        fullName: fullName.trim(),
        email: email.trim(),
        phone: phone.trim(),
      });
    }
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="invite-member-modal">
      <Modal.Header closeButton>
        <Modal.Title as="h2" className="h5 mb-0">
          Invite member
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <p className="text-muted small mb-4">
            Send an invitation by email. They will get a link to join once invitations are enabled.
          </p>
          <YFormField label="Full name" htmlFor="invite-member-name" required>
            <YInput
              id="invite-member-name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="e.g. Jordan Mills"
              autoComplete="name"
            />
          </YFormField>
          <YFormField label="Email address" htmlFor="invite-member-email" required className="mt-3">
            <YInput
              id="invite-member-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@example.com"
              autoComplete="email"
            />
          </YFormField>
          <YFormField
            label="Phone (optional)"
            htmlFor="invite-member-phone"
            help="We will only use this for club-related texts if you enable SMS later."
            className="mt-3"
          >
            <YInput
              id="invite-member-phone"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="(555) 000-0000"
              autoComplete="tel"
            />
          </YFormField>
        </Modal.Body>
        <Modal.Footer className="d-flex flex-wrap gap-2 justify-content-end">
          <YButton type="button" variant="ghost" onClick={onHide}>
            Cancel
          </YButton>
          <YButton type="submit" variant="primary">
            Send invite
          </YButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default InviteMemberModal;
